/**
 * Edit estimate handler.
 */
import { beginEstimateEdit } from '../../modules/estimates';
import type { TableHandlerDeps } from './types';

export function handleEditEstimate(id: string, e: Event, deps: TableHandlerDeps): void {
  const { state } = deps;

  const lot = state.lots.find((x: unknown) => (x as { id: string }).id === id);
  if (!lot) return;

  e.preventDefault();
  beginEstimateEdit(lot, state);
}
